import { useCallback, useEffect, useRef } from "react";

export type IsMountedFunction = () => boolean;

export function useIsMounted(): IsMountedFunction {
  const isMountedRef = useRef(true);
  const isMounted = useCallback(() => isMountedRef.current, []);

  useEffect(() => {
    return () => void (isMountedRef.current = false);
  }, []);

  return isMounted;
}
